import React, { useEffect, useState } from "react";
import { BunnyVideoPlayer } from "../../../components/common/BunnyVideo.Component";
import { VideoApi } from "../../../video/Video.Api";
import { VideoBunnyCdn } from "../../../video/Video.Model";
import { ContentItemDataVideoUpload } from "../../Content.model";
import { ContentItemViewProps } from "../ContentItem.model";
import { ContentApi } from "../../Content.Api";
import { Loader } from "../../../components/common/Loader.component";

export function ContentItemViewVideoUpload(props: ContentItemViewProps) {
  let data: ContentItemDataVideoUpload = props.data;

  let [video, setVideo] = useState<VideoBunnyCdn>();
  let [loading, setLoading] = useState<boolean>();

  function fetchVideo() {
    if (data.video) {
      setVideo(video);
    } else if (props.item.id) {
      setLoading(true);
      ContentApi.getCi(props.item.id)
        .executeV2()
        .then((ci) => {
          let videoContent = ci.data as ContentItemDataVideoUpload;
          setVideo(videoContent.video);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }
  useEffect(fetchVideo, [data.videoId]);

  return (
    <div className="ContentItemInputVideoUpload">
      {loading && <Loader />}
      {video && (
        <>
          <BunnyVideoPlayer
            maxWidth="100%"
            libraryId={video.libraryId}
            videoId={video.bunnyId}
          />
        </>
      )}
    </div>
  );
}
